import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    Handler,
    replaceInChain
} from "@insite/client-framework/HandlerCreator";
import {
    GetProductByIdApiV2Parameter,
    GetProductVariantChildApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    variantId?: string;
    productId?: string;
    searchTerm?: string;
    validateProduct?: boolean;
    skipInventoryValidation?: boolean;
    denyFixedConfiguration?: boolean;
}

interface Props {
    apiParameter: GetProductByIdApiV2Parameter | GetProductVariantChildApiV2Parameter;
    variantChildren?: ProductModel[] | null;
    product?: ProductModel;
    productInfo?: ProductInfo;
}

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterExtension: HandlerType = props => {
    if (props.parameter.variantId && props.parameter.productId) {
        props.apiParameter = {
            id: props.parameter.variantId,
            variantParentId: props.parameter.productId,
            expand: ["detail", "properties"],
        };
    } else if (props.parameter.productId) {
        props.apiParameter = {
            id: props.parameter.productId,
            expand: ["detail", "variantTraits", "properties"],
        };
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtension);